"use strict";

angular.module("admin")

	.controller("AdminExportTemplatesCtrl", [ "exportTemplates", "consumers", "$scope", "Utils", "$uibModal", "SecurityService", "AdminExportTemplatesService", "toastr", "$location", "AdminClientsService", "ENV", "ExploitationService", "OpenExportsService","FaresService","FlexService", "$interval", "$q", "$window",
		function (exportTemplates, consumers, $scope, Utils, $uibModal, SecurityService, AdminExportTemplatesService, toastr, $location, AdminClientsService, ENV, ExploitationService, OpenExportsService,FaresService,FlexService, $interval, $q, $window) {
		$scope.data = {
			exportTemplates: exportTemplates.data,
			exportTemplate: exportTemplates.data ? exportTemplates.data : { description: "" },
			consumers: consumers.data ? consumers.data : [],
			// needed by the tch-network-selector
			selectedNetwork: {},
			networks: [],
			networkLines: {},
			lines: [],
			fetchMosaicData: false, // we don't want to fetch mosaic networks
			countDisplayCheckBoxAllLines: false,
			countDisplayCheckBoxAllLinesByNetwork: [],
			countDisplayCheckBoxAllReferentials: false,
			availablePostProcesses:[],
			selectedPostProcess: null,
			exportDetailDefinedMap: new Map(),
			isSuperAdmin: SecurityService.hasRight("ROLE_SUPER_ADMINISTRATEUR"),
			hasFaresData: false,
			hasFlexData: true,
			scheduleNetexFaresExport: false,
			scheduleNetexFaresExportDate: {
				// Sunday is at index 0, Monday is at index 1
				days: [false, false, false, false, false, false, false],
				time: new Date(0)
			}
		};



		if ($scope.data.exportTemplate && $scope.data.exportTemplate.id && $scope.data.exportTemplate.type === "NETEX_FARES") {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				AdminExportTemplatesService
					.getCron($scope.data.exportTemplate.id, referential.id)
				   	.then((response) => {
						const cronExpression = response.data;
						$scope.parseCronExpression(cronExpression);
					})
					.catch(() => toastr.error("Problème lors de la récupération de la planification de l'export", "Erreur"));
			});
		}

		$scope.parseCronExpression = function(cronExpression) {
			$scope.data.scheduleNetexFaresExport = !!cronExpression;
			if ($scope.data.scheduleNetexFaresExport) {
				const minutes = cronExpression.split(" ")[1];
				const hours = cronExpression.split(" ")[2];
				const days = cronExpression.split(" ")[5].split(",");
				for (let i = 0; i < days.length; i++) {
					// QUARTZ CRON expression's day of week is in range 1-7 (from sunday (1) to saturday (6))
					$scope.data.scheduleNetexFaresExportDate.days[days[i] - 1] = true;
				}
			}
		}

		$scope.buildScheduleCronExpression = function () {
			const days = [];
			for (let i = 0; i < $scope.data.scheduleNetexFaresExportDate.days.length; i++) {
				if ($scope.data.scheduleNetexFaresExportDate.days[i]) {
					// QUARTZ CRON expression's day of week is in range 1-7 (from sunday (1) to saturday (6))'
					// we add + 1 to get the correct day of week in the CRON expression
					days.push(i + 1);
				}
			}
			return `0 ${$scope.data.scheduleNetexFaresExportDate.time.getMinutes()} ${$scope.data.scheduleNetexFaresExportDate.time.getHours()} ? * ${days.join(",")} *`;
		}

		$scope.orderByField = "name";
		$scope.reverseSort = false;
		$scope.status = {
			isNetworkAccordionOpen: []
		};

		if ($scope.data.exportTemplate.agencyTimezone === undefined || $scope.data.exportTemplate.agencyTimezone == null){
			$scope.data.exportTemplate.agencyTimezone = "Europe/Paris";
		}

		if ($scope.data.exportTemplate.agencyLang === undefined || $scope.data.exportTemplate.agencyLang == null){
			$scope.data.exportTemplate.agencyLang = "FR";
		}

		if ($scope.data.exportTemplate.agencyId != null) {
			$scope.data.exportTemplate.uniqueAgency = true;

		}

        if ($scope.data.exportTemplate.exportGeneratedMissingQuays != null) {
            $scope.data.exportGeneratedMissingQuays = $scope.data.exportTemplate.exportGeneratedMissingQuays;
        }

        if ($scope.data.exportTemplate.exportExternalIds != null) {
            $scope.data.exportExternalIds = $scope.data.exportTemplate.exportExternalIds;
        }

		if ($window._env_.IS_FARES_ACTIVATED === "true"){
			AdminClientsService.getCurrentClient().then((client) => {
				FaresService.hasData(client.code.toUpperCase()).then((response) => {
					$scope.data.hasFaresData = response.data.hasData;
				});
			});
		}


		if ($window._env_.IS_FLEX_ACTIVATED === "true"){
			AdminClientsService.getCurrentClient().then((client) => {
				FlexService.hasData(client.code.toUpperCase()).then((response) => {
					$scope.data.hasFlexData = response.data.hasData;
					debugger;;
				});
			});
		}




		ExploitationService.getAvailablePostProcesses().then((response) => {
			const data = response.data;
			if (data != null){
				for (let element of data) {
					$scope.data.availablePostProcesses.push(element);
				}
			}
		}).catch(() => $scope.data.availablePostProcesses = []);

		if ($scope.data.exportTemplate != null){
			$scope.data.selectedPostProcess = $scope.data.exportTemplate.postProcess;
		}

		$scope.data.referential = window.sessionStorage.getItem("referential");

		AdminClientsService.watchUserClients((clients) => {
			$scope.data.referentials = clients.filter(c => c.name.toLowerCase() !== "technique");
		});

		$scope.changeOrder = function (field) {
			if ($scope.orderByField === field) {
				$scope.reverseSort = !$scope.reverseSort;
			} else {
				$scope.orderByField = field;
				$scope.reverseSort = false;
			}
		};


		$scope.loadNetworksAndLines = function () {
			if ($scope.data.exportTemplate && $scope.data.exportTemplate.type === "GTFS") {
				if (!$scope.data.exportTemplate.lines) {
					$scope.data.exportTemplate.lines = [];
				}

				if (!$scope.data.exportTemplate.referentials) {
					$scope.data.exportTemplate.referentials = [];
				}

				ExploitationService.getNetworkWithLines($scope.data.fetchMosaicData).then(function (response) {
					$scope.data.networkLines = response.data;
					if ($scope.data.networkLines && $scope.data.networkLines.length > 0) {

						if ($scope.data.exportTemplate.exportAllLines) {
							$scope.data.exportTemplate.lines = [];
							$scope.data.networkLines.forEach(network => {
								network.lines.forEach(line => {
									$scope.data.exportTemplate.lines.push(line);
								});
							});
						}

						$scope.data.networkLines.forEach(network => {
							$scope.status.isNetworkAccordionOpen[network.id] = false;
							network.lines.forEach(line => {
								$scope.data.lines[line.id] = $scope.data.exportTemplate.lines.some(l => l.id === line.id);
							});
						});
						checkAllLinesChecked();
					}
				});
			}
		};

		$scope.loadNetworksAndLines();

		$scope.cloudURLFile = ENV.CLOUD_FILE_URL;

		if ($scope.data.exportTemplate && $scope.data.exportTemplate.lines && $scope.data.exportTemplate.lines.length > 0) {
			$scope.data.currentNetwork = $scope.data.exportTemplate.lines[0].network.id;
		}

		$scope.exportedFileNameRegEx = "^[^.]+.zip$";

		AdminClientsService.getAllClients(true).then(
			function (clients) {
				const client = clients.data.find(e => e.code === window.sessionStorage.getItem("referential"));
				if (client != null) {
					$scope.currentMosaicId = client.mosaicId;
				}
			});

		$scope.downloadFile = function (jobId, name) {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
					AdminClientsService.getParentReferentialId(referential.id).then((parentRefId) => {
							OpenExportsService.getOfferExportFile(parentRefId, jobId)
								.then((response) => {
									let blob = new Blob([response.data], {type: "octet/stream"});
									let a = document.createElement("a");
									a.href = (window.URL || window.webkitURL).createObjectURL(blob);
									a.target = "_blank";
									a.download = name !== "" ? name : response.headers(["rutebankenfilename"]);
									document.body.appendChild(a);
									a.click();
								}).catch(function (data) {
									toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
								});
						});
				});
		};

		$scope.downloadFileFromStatic = function (exportTemplate) {

			let url;
			if ($scope.hasPublicUrlConsumer(exportTemplate)){
				url = ENV.API_URL.replace("/api-proxy/api/offre/1.0/","")  + "/static/mobiiti_technique/" + exportTemplate.exportedFileName;
			} else {
				if (exportTemplate.type === "GTFS") {
					url = ENV.API_URL.replace("/api-proxy/api/offre/1.0/", "") + "/static/mobiiti_technique/gtfs/" + exportTemplate.idFormat + "/export_global_gtfs.zip";
				} else {
					url = ENV.API_URL.replace("/api-proxy/api/offre/1.0/", "") + "/static/mobiiti_technique/netex/export_global_netex.zip";
				}
			}

			// Création de l'élément <a> pour le téléchargement
			var lien = document.createElement("a");
			lien.href = url;
			lien.download = "";

			// Ajout de l'élément <a> au DOM et simulation du clic
			document.body.appendChild(lien);
			lien.click();

			// Suppression de l'élément <a> du DOM
			document.body.removeChild(lien);

		};

		$scope.getFileNameFromPath  = function (filePath) {
			let pathArray = filePath.split("/");
			return pathArray[pathArray.length-1];
		};

		$scope.downloadStopFile = function (name) {
			AdminClientsService.getAllClients(false).then((clients) => {
				const client = clients.data.find(e => e.code === window.sessionStorage.getItem("referential"));
				OpenExportsService.getStopPlaceFile(client.code, name)
					.then((response) => {
						let blob = new Blob([response.data], {type: "octet/stream"});
						let a = document.createElement("a");
						a.href = (window.URL || window.webkitURL).createObjectURL(blob);
						a.target = "_blank";
						a.download = $scope.getFileNameFromPath(name);
						document.body.appendChild(a);
						a.click();
					}).catch(() => {
					toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
				});

			});
		};

			$scope.openServiceJourneyInformationsModal = function() {
				Utils.openModal($uibModal, "serviceJourneyInformations.html", $scope);
			};


			$scope.downloadFaresFile = function (jobId, fileName) {
				OpenExportsService.getNetexFaresExportFile(jobId)
					.then((response) => {
						let blob = new Blob([response.data], {type: "octet/stream"});
						let a = document.createElement("a");
						a.href = (window.URL || window.webkitURL).createObjectURL(blob);
						a.target = "_blank";
						a.download = fileName;
						document.body.appendChild(a);
						a.click();
					})
					.catch(() => toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement"))
			}


		$scope.edit = function () {
			if ($scope.isNetexFares() && $scope.data.scheduleNetexFaresExport && !$scope.data.scheduleNetexFaresExportDate.days.includes(true)) {
				toastr.error("Veuillez sélectionner au moins un jour d'application pour la planification de l'export");
				return;
			}
			if ($scope.data.exportGeneratedMissingQuays != null) {
				$scope.data.exportTemplate.exportGeneratedMissingQuays = $scope.data.exportGeneratedMissingQuays;
			}
			if ($scope.data.exportExternalIds != null) {
				$scope.data.exportTemplate.exportExternalIds = $scope.data.exportExternalIds;
			}
			if ($scope.isGtfs()) {
				// pour éviter les pbs de conversion json à l'enregistrement
				$scope.data.exportTemplate.lines.forEach(l => {
					l.network = undefined;
					l.company = undefined;
				});
			} else {
				$scope.data.exportTemplate.lines = [];
			}
			$scope.data.exportTemplate.postProcess = $scope.data.selectedPostProcess;
			if (!$scope.data.exportTemplate.uniqueAgency){
				delete $scope.data.exportTemplate.agencyName;
				delete $scope.data.exportTemplate.agencyURL;
				delete $scope.data.exportTemplate.agencyTimezone;
				delete $scope.data.exportTemplate.agencyLang;
				delete $scope.data.exportTemplate.agencyId;
			}
			$scope.data.exportTemplate.exportAllLines = $scope.data.exportTemplate.exportAllLines || $scope.isGtfsGlobal();

			$scope.apiPersist(
				() => AdminExportTemplatesService.save($scope.data.exportTemplate).then(response => {
					if (response.status === 200) {
						$scope.editScheduleCron(response.data.id);
					}
				}),
				"Sauvegarde du modèle d'export",
				true
			);
		};

		$scope.editScheduleCron = function (exportTemplateId) {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				if (!!$scope.data.exportTemplate.id && (!$scope.isNetexFares() || !$scope.data.scheduleNetexFaresExport)) {
					// Delete export schedule in case in was scheduled before
					$scope.apiPersist(
						() => AdminExportTemplatesService.deleteCron(exportTemplateId, referential.id),
						"Suppression de la planification de l'export",
						false
					);
				} else if ($scope.isNetexFares() && $scope.data.scheduleNetexFaresExport) {
					const cronExpression = $scope.buildScheduleCronExpression();
					$scope.apiPersist(
						() => AdminExportTemplatesService.updateCron(exportTemplateId, referential.id, cronExpression),
						"Sauvegarde de la planification de l'export",
						false
					);
				}
			})
		};

		$scope.isGtfs = function () {
			return $scope.data.exportTemplate && $scope.data.exportTemplate.type === "GTFS" && $scope.data.referential !== "technique";
		};

		$scope.isNetex = function () {
			return $scope.data.exportTemplate && $scope.data.exportTemplate.type === "NETEX" && $scope.data.referential !== "technique";
		};

		$scope.isNetexStops = function () {
			return $scope.data.exportTemplate && $scope.data.exportTemplate.type === "ARRET" ;
		};

		$scope.isNetexFares = function () {
			return $scope.data.exportTemplate && $scope.data.exportTemplate.type === "NETEX_FARES" ;
		};

		$scope.isGtfsGlobal = function () {
			checkAllReferentialsChecked();
			return $scope.data.exportTemplate && $scope.data.exportTemplate.type === "GTFS" && $scope.data.referential === "technique";
		};

		$scope.isNetexGlobal = function () {
			checkAllReferentialsChecked();
			return $scope.data.exportTemplate && $scope.data.exportTemplate.type === "NETEX" && $scope.data.referential === "technique";
		};

		$scope.getDefaultIDFormat = function () {
			if ($scope.data.exportTemplate.idFormat !== null && $scope.data.exportTemplate.idFormat !== undefined) {
				return $scope.data.exportTemplate.idFormat;
			}
			return "SOURCE";
		};

		$scope.delete = function (id) {
			const onSuccess = (id) => {
				return () => {
					AdminClientsService.getReferentialIdAndUser().then(
						(referential) => {
							AdminExportTemplatesService.deleteCron(id, referential.id);
							$scope.data.exportTemplates = $scope.data.exportTemplates.filter(e => e.id !== id);
						});
				}
			};
			$scope.apiPersist(
				() => AdminExportTemplatesService.delete(id),
				"Suppression du modèle d'export",
				true,
				onSuccess(id)
			);
		}

		$scope.export = function (exportTemplate) {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
					OpenExportsService.exportById(referential.id, referential.user, exportTemplate.id)
						.then(() => {
							exportTemplate.lastExecutionState = "En cours";
							exportTemplate.status = "PROCESSING";
							toastr.success("", "Export prédéfini démarré");
						}).catch(() => {
							toastr.error("Problème lors de l'export");
						});
				});
		};

		$scope.hasPublicUrlConsumer = (exportTemplate) => {
			return exportTemplate.consumers.some(consumer => consumer.type === "URL");
		};

		$scope.hasCloudFileURLDefined = () => {
			return ENV.CLOUD_FILE_URL !== "EMPTY_URL";
		};

		$scope.hasExportFileDefined = (exportTemplate) => {
			if (exportTemplate.exportJobId !== null && exportTemplate.exportJobId !== undefined){
				return true;
			}
			return false;
		};

		$scope.addConsumer = (consumer) => {
			if (!angular.isArray($scope.data.exportTemplate.consumers)) {
				$scope.data.exportTemplate.consumers = [];
			}
			$scope.data.exportTemplate.consumers.push(consumer);
		};


		$scope.getExportFileNameFromType = (type) => {
			switch (type) {
			case "GTFS":
				return "gtfs";
			case "NETEX":
				return "netex_offre";
			case "ARRET":
				return "netex_arrets";
			}
		};


		$scope.removeConsumer = (consumer) => {
			$scope.data.exportTemplate.consumers = $scope.data.exportTemplate.consumers.filter(c => c.id !== consumer.id);
		};		

		/**
		 * Lance un appel vers l'api pour persister les changements sur la configuration des exports
		 * @param apiCall Fonction d'appel vers l'api
		 * @param operationLabel Nom de l'opération
		 * @param redirect Redirige vers la page des templates d'export si truthy
		 * @param onSuccess Fonction callback sur succès
		 */
		$scope.apiPersist = (apiCall, operationLabel, redirect, onSuccess) => {
			apiCall().then(() => {
				if (angular.isFunction(onSuccess)) {
					onSuccess();
				}
				toastr.success("", operationLabel + " réussie");
				if (redirect) {
					$location.path("/admin/export-templates");
				}
			}).catch(function (response) {
				const data = response.data;
				let errorMessage = "Erreur lors de la " + operationLabel;
				if (data !== undefined && data.message) {
					errorMessage += data.message;
				}
				toastr.error(errorMessage, "Erreur");
			});
		};

		// Changement d'état de la ligne pour la prendre en compte dans l'exportation
		$scope.addLineToExport = function (line, checked) {
			$scope.data.lines[line.id] = checked;
			if (checked) {
				$scope.data.exportTemplate.lines.push(line);
			} else {
				$scope.data.exportTemplate.lines = $scope.data.exportTemplate.lines.filter(l => l.id !== line.id);
			}
		};


		// Ajouter une ligne à exporter
		$scope.addOneLineToExport = function (line) {
			$scope.addLineToExport(line, !$scope.data.lines[line.id]);
			checkAllLinesChecked();
		};

		// Ajouter toutes les lignes à exporter
		$scope.addAllLinesToExport = function () {
			$scope.data.exportTemplate.exportAllLines = !$scope.data.exportTemplate.exportAllLines;
			if ($scope.data.exportTemplate.exportAllLines){
				$scope.data.networkLines.forEach(network => {
					network.lines.forEach(line => {
						$scope.addLineToExport(line, $scope.data.exportTemplate.exportAllLines);
					});
				});
				checkAllLinesChecked();
			}

		};

		// Ajouter toutes les lignes d'un réseau à exporter
		$scope.addAllLinesToExportByNetwork = function (networkId) {
			$scope.data.networkLines.forEach(network => {
				if (network.id === networkId) {
					network.lines.forEach(line => {
						$scope.addLineToExport(line, !$scope.data.countDisplayCheckBoxAllLinesByNetwork[networkId]);
					});
				}
			});
			checkAllLinesChecked();
		};

		function checkAllLinesChecked() {
			$scope.data.networkLines.forEach(network => {
				$scope.data.countDisplayCheckBoxAllLinesByNetwork[network.id] = true;
				checkAllLinesByNetworkChecked(network.lines);
			});
		}

		function checkAllLinesByNetworkChecked(lines) {
			lines.forEach(line => {
				if (!$scope.data.lines[line.id]) {
					$scope.data.countDisplayCheckBoxAllLinesByNetwork[line.network] = false;
				}
			});

			return $scope.data.exportTemplate.exportAllLines;
		}


		// Ajouter tous les référentiels à exporter
		$scope.addAllReferentialsToExport = function () {
			$scope.data.referentials.forEach(referential => {
				$scope.addReferentialToExport(referential, !$scope.data.countDisplayCheckBoxAllReferentials);
			});
			checkAllReferentialsChecked();
		};

		// Ajouter un référentiel à exporter
		$scope.addOneReferentiaToExport = function (referential) {
			$scope.addReferentialToExport(referential, !$scope.data.exportTemplate.referentials.includes(referential.code));
			checkAllReferentialsChecked();
		};

		// Changement d'état du référentiel pour le prendre en compte dans l'exportation
		$scope.addReferentialToExport = function (referential, checked) {
			if (checked) {
				$scope.data.exportTemplate.referentials.push(referential.code);
			} else {
				$scope.data.exportTemplate.referentials = $scope.data.exportTemplate.referentials.filter(r => r !== referential.code);
			}
		};

		function checkAllReferentialsChecked() {
			$scope.data.countDisplayCheckBoxAllReferentials = true;
			$scope.data.referentials.forEach(referential => {
				if ($scope.data.exportTemplate.referentials != null && !$scope.data.exportTemplate.referentials.includes(referential.code)) {
					$scope.data.countDisplayCheckBoxAllReferentials = false;
				}
			});

			return $scope.data.countDisplayCheckBoxAllReferentials;
		}

		$scope.referentialIsChecked = function (referential) {
			return $scope.data.exportTemplate.referentials.includes(referential.code);
		};

		$scope.mapDate = function(timestamp) {
			const date = new Date(timestamp);
			return date.toLocaleString("fr-FR");
		};

		$scope.mapTimetableStatus = function (timetable) {
			if (timetable && angular.isArray(timetable.events)) {
				const lastEvent = timetable.events[timetable.events.length - 1];
				const jobState = lastEvent.state;
				return $scope.mapStatus(jobState);
			}
		};

		$scope.mapStatus = function (jobState) {
			return OpenExportsService.mapJobStateToExportStatus(jobState);
		};

		$scope.getReferentialIdentifier = function () {
			if ($scope.data.referentialId) {
				return $q.when($scope.data.referentialId);
			} else {
				return AdminClientsService.getReferentialId();
			}
		};

		$scope.buildQueryParamsGetLatestGlobalExport = function (exportTemplate) {
			const params = new Map();
			params.set("latest", "true");
			if (exportTemplate.type === "NETEX") {
				params.set("action", "EXPORT_NETEX_MERGED");
				params.set("fileName", exportTemplate.exportedFileName);
			} else {
				params.set("action", "EXPORT_GTFS_MERGED");
				params.set("fileName", "export-" + exportTemplate.id + "-" + exportTemplate.name);
			}
			return params;
		}

		$scope.buildQueryParamsGetLatestStandardExport = function (exportTemplate, typeJob) {
			const params = new Map();
			params.set("state", "OK");
			params.set("latest", "true");
			params.set("action", typeJob);
			const fileName = exportTemplate.exportedFileName
				|| (exportTemplate.type === "NETEX" ? "offre" : exportTemplate.name.replace(/ /g, "_"));
			params.set("fileName", fileName);
			return params;
		}

		$scope.fetchData = function () {
			if (angular.isArray($scope.data.exportTemplate)) {
				$scope.data.exportTemplate.forEach(exportTemplate => {
					if (exportTemplate.type === "NETEX" || exportTemplate.type === "GTFS") {
						AdminExportTemplatesService.getAllByTemplateId(exportTemplate.id).then(response => {
							$scope.data.exportDetailDefinedMap.set(exportTemplate.id, response.status === 200 && response.data.length);
						});
						$scope.getReferentialIdentifier().then(data => {
							if (data) {
								$scope.data.referentialId = data;
								if ($scope.data.referential === "technique") {
									let latestSuccessQueryParams = $scope.buildQueryParamsGetLatestGlobalExport(exportTemplate);
									latestSuccessQueryParams.set("state", "OK");
									OpenExportsService.getExportInfo(data, latestSuccessQueryParams).then(response => {
										if (response.status === 200 && response.data && response.data[0]) {
											exportTemplate.lastExecutionTime = $scope.mapDate(response.data[0].lastEvent);
										}
									});
									OpenExportsService.getExportInfo(data, $scope.buildQueryParamsGetLatestGlobalExport(exportTemplate)).then(response => {
										if (response.status === 200 && response.data && response.data[0]) {
											exportTemplate.lastExecutionState = $scope.mapTimetableStatus(response.data[0]);
										}
									});
								} else {
									const typeJob = exportTemplate.type === "NETEX" ? "EXPORT_NETEX" : "EXPORT";
									const params = $scope.buildQueryParamsGetLatestStandardExport(exportTemplate, typeJob);
									OpenExportsService.getExportInfo(data, params).then(response => {
										if (response.status === 200 && response.data && response.data[0]) {
											exportTemplate.lastExecutionTime = $scope.mapDate(response.data[0].lastEvent);
										}
									});
								}

							}
						});
					} else {
						$scope.data.exportDetailDefinedMap.set(exportTemplate.id, true);
						let exportType = "NETEX_STOP_PLACE_QUAY";
						if (exportTemplate.type === "POI") {
							exportType = "NETEX_POI";
						} else if (exportTemplate.type === "PARKING") {
							exportType = "NETEX_PARKING";
						}

						OpenExportsService.getLatestSuccessfulTiamatJobByType(exportType).then(response => {
							if (response.status === 200) {
								exportTemplate.lastExecutionTime = $scope.mapDate(response.data.started * 1000);
							}
						});

						OpenExportsService.getLatestTiamatJobByType(exportType).then(response => {
							if (response.status === 200) {
								exportTemplate.lastExecutionState = $scope.mapStatus(response.data.status);
							}
						});
					}
				});
			}
		};

		$scope.validateFilename = function() {
			const regex = /^[a-zA-Z0-9_-]+\.zip$/;
			const filename = $scope.data.exportTemplate.exportedFileName;
			if (!filename) {
				$scope.editForm.exportedFileName.$setValidity("customPattern", true);
				return;
			}

			const isValid = regex.test(filename);
			$scope.editForm.exportedFileName.$setValidity("customPattern", isValid);
		};

		$scope.fetchData();

		const pollingReference = $interval($scope.fetchData, 10000);

		$scope.isInvalidDescription = function() {
			return $scope.data.exportTemplate.description && $scope.data.exportTemplate.description.length > 255;
		}

		$scope.$on("$destroy", () => {
			if (pollingReference) {
				$interval.cancel(pollingReference);
			}
		});
	}]);
